import type { NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import Layout from 'src/components/common/layout/Layout';
import LoginForm from 'src/components/forms/login/LoginForm';
import { getStaticPaths, makeStaticProps } from 'src/utils/helpers/getStatic';

const getStaticProps = makeStaticProps(['login']);
export { getStaticPaths, getStaticProps };

const LoginPage: NextPage = () => {
    const { t } = useTranslation('login');

    return (
        <Layout backUrl="/" bottombar={false} title={t('page-title')}>
            <LoginForm />
        </Layout>
    );
};

export default LoginPage;
